// API and S3 Configuration
export const S3_BUCKET = 'soyoucanhearmewhenimgone';
export const S3_REGION = 'us-west-2';
export const S3_BASE_URL = `https://${S3_BUCKET}.s3.${S3_REGION}.amazonaws.com`;
export const S3_FEED_URL = `${S3_BASE_URL}/feed.xml`;

// Podcast Platform URLs
export const APPLE_PODCASTS_URL = 'https://podcasts.apple.com/us/podcast/so-you-can-hear-me-when-im-gone/id1546289413';
export const SPOTIFY_URL = 'https://open.spotify.com/show/5YrcUfdkvJh813ODBH85dC';

// Build-time generated search index
export const SEARCH_INDEX_URL = '/search-index.json';

// Audio Clip Export Limits
export const MAX_CLIP_SECONDS = 20 * 60; // 20 minutes
export const MAX_SAFE_DECODE_BYTES = 20 * 1024 * 1024; // 20 MB

// Debounce timeouts
export const SAVE_STATE_DEBOUNCE_MS = 5000; // 5 seconds

// Playback speed options
export const PLAYBACK_SPEEDS = [0.5, 1, 1.25, 1.5, 2];

// Skip intervals (seconds)
export const SKIP_BACKWARD_SECONDS = 10;
export const SKIP_FORWARD_SECONDS = 10;

// Search configuration
export const SEARCH_CONFIG = {
  threshold: 0.3,
  minMatchCharLength: 2,
  ignoreLocation: true,
  keys: ['title', 'summary', 'aiSummary', 'fullText'],
  includeMatches: true,
  includeScore: true
};
